<template>
  <div v-if="value" data-automation-id="xer-sync-point" class="sync-point">{{ value }}</div>
</template>

<script>
export default {
  name: 'XerAutomationSyncPoint',
  props: {
    value: {
      type: String,
      required: false,
      default: undefined
    }
  }
};
</script>

<style lang="scss" scoped>
.sync-point {
  visibility: hidden;
  position: absolute;
}
</style>
